import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  LayoutDashboard,
  Shield,
  LogIn,
  LogOut,
  Activity,
} from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="border-b border-gray-800 bg-gray-950/80 backdrop-blur-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Brand */}
          <Link to="/" className="flex items-center gap-3 group">
            <div className="w-9 h-9 rounded-lg bg-brand-600 flex items-center justify-center group-hover:bg-brand-500 transition-colors">
              <Activity className="w-5 h-5 text-white" />
            </div>
            <div>
              <h1 className="text-lg font-semibold text-white leading-tight">
                Akrithi Labs
              </h1>
              <p className="text-[10px] text-gray-500 uppercase tracking-wider leading-tight">
                Production Monitor
              </p>
            </div>
          </Link>

          {/* Navigation */}
          <div className="flex items-center gap-1">
            <NavLink to="/" active={isActive("/")} icon={LayoutDashboard}>
              Dashboard
            </NavLink>

            {user ? (
              <>
                <NavLink
                  to="/admin"
                  active={isActive("/admin")}
                  icon={Shield}
                >
                  Admin
                </NavLink>
                <button
                  onClick={logout}
                  className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-gray-400 hover:text-white hover:bg-gray-800 transition-colors"
                >
                  <LogOut className="w-4 h-4" />
                  <span className="hidden sm:inline">Logout</span>
                </button>
              </>
            ) : (
              <NavLink
                to="/login"
                active={isActive("/login")}
                icon={LogIn}
              >
                Login
              </NavLink>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

function NavLink({ to, active, icon: Icon, children }) {
  return (
    <Link
      to={to}
      className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm transition-colors ${
        active
          ? "bg-brand-600/20 text-brand-400"
          : "text-gray-400 hover:text-white hover:bg-gray-800"
      }`}
    >
      <Icon className="w-4 h-4" />
      <span className="hidden sm:inline">{children}</span>
    </Link>
  );
}
